import { SEVERITY } from "helpers/utils.js";
import {
  GET_PAGING_CODE_COLOR,
  GET_PAGING_CODE_COLOR_SUCCESS,
  GET_CODE_COLOR_BY_ID_SUCCESS,
  GET_PAGING_CODE_COLOR_ERROR,
  CODE_COLOR_CLEAR_ERROR,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
  message: null,
};

const StockIn = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_PAGING_CODE_COLOR:
      return {
        ...state,
        loading: true,
      };
    case GET_PAGING_CODE_COLOR_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_CODE_COLOR_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_PAGING_CODE_COLOR_ERROR:
      let hasUniqueCode = payload.includes("UNIQUE_Code");
      return {
        ...state,
        message: {
          title: "Item",
          text: hasUniqueCode ? "Item is duplicate code." : payload,
          severity: SEVERITY.DANGER,
        },
      };
    case CODE_COLOR_CLEAR_ERROR:
      return {
        ...state,
        loading: false,
        message: null,
      };
    default:
      return state;
  }
};

export default StockIn;
